import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery";

export default function personal_cards(): any[] {
    return [
        {
            "border_radius": 1,
            "gap": 30,
            carousel_nav_type: NAVIGATION_DESIGN_TYPE.LONG_ARROW,
            carousel_nav_position: NAVIGATION_POSITION_TYPE.MIDDLE_OUTER,
            carousel_nav: NAVIGATION_TYPE.ROUND,
            carousel_nav_size: NAVIGATION_SIZE_TYPE.LARGE,
            "card_fields": {
                "avatarMedallion": {
                    "radius": 150,
                    "margin": 2,
                    "hover_size": 8,
                    "icon": "https://i.pinimg.com/736x/01/29/85/012985ea99c16d87137ffcdbb92046b0.jpg"
                },
                order: {
                    style: {
                        textAlign: "center"
                    },
                    significant_zero: true
                },
                display_name: {
                    "style": {
                        "padding": 12 
                    }
                },
                "first_name": {
                    "style": {
                        "padding": 0,
                        "paddingTop": 12
                    }
                },
                "last_name": {
                    "style": {
                        "padding": 0,
                        "paddingBottom": 12
                    }
                },
                "description": {
                    "style": {
                        "padding": "0 12px 12px 12px",
                        "fontSize": ".9em",
                        "letterSpacing": 1
                    }
                },
                "divider": {},
                "links": {
                    "personalLinkType": "small_minimal",
                    "style": {
                        "padding": "12px 0"
                    }
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "1",
                            "title": "Известность"
                        },
                        {
                            "id": "2",
                            "title": "Порядочность"
                        },
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Чистоплотность"
                        }
                    ],
                    "min": 0,
                    "max": 9
                }
            },
        },
        {            
            "border_radius": 1,
            "gap": 30,
            "card_fields": {
                "avatar": {
                    "height": 320,
                    "margin": 2,
                    "hover_size": 8,
                    "icon": "https://i.pinimg.com/736x/01/29/85/012985ea99c16d87137ffcdbb92046b0.jpg",
                    "style": {
                        "height": 320
                    }
                },
                "first_name": {
                    "style": {
                        "padding": 0,
                        "paddingTop": 12
                    }
                },
                "last_name": {
                    "style": {
                        "padding": 0,
                        "paddingBottom": 12
                    }
                },
                "display_name": {
                    "style": {
                        "padding": 12,
                        "fontWeight": 700,
                        "fontSize": "1.1em",
                    }
                },
                "description": {
                    "style": {
                        "padding": "0 12px 12px 12px",
                        "fontSize": ".9em",
                        "letterSpacing": 1
                    }
                },
                order: {
                    significant_zero: true,
                    card_fields_style: {
                        marginTop: -18,
                        transform: "translateX(calc(50% - 18px))"
                    },
                    style: {                        
                        width: 46,
                        height:46,
                        display: "flex",
                        justifyContent:"center",
                        alignItems: "center",
                        borderRadius: 46,
                        backgroundColor: "var(--force-plain-color)", 
                        color: "var(--force-contrast-opacity-color)",
                        fontSize: 16,
                    }
                },
                "divider": {},
                "links": {
                    "personalLinkType": "small",
                    "style": {
                        "padding": "12px 0"
                    }
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "1",
                            "title": "Известность"
                        },
                        {
                            "id": "2",
                            "title": "Порядочность"
                        },
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Чистоплотность"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "roles": {
                    "className": "my-4",
                    "style": {
                        "padding": "20px 0"
                    }
                }
            },
        },
        {
            "border_radius": 1,
            "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'",
            "grids": [
                {
                    "display": "grid",
                    "gridColumnStart": 1,
                    "gridColumnEnd": 2,
                    "gridRowStart": 1,
                    "gridRowEnd": 7
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 1,
                    "gridRowEnd": 2
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 2,
                    "gridRowEnd": 3
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 3,
                    "gridRowEnd": 4
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 4,
                    "gridRowEnd": 5
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 5,
                    "gridRowEnd": 6
                },
                {
                    "display": "grid",
                    "gridColumnStart": 2,
                    "gridColumnEnd": 4,
                    "gridRowStart": 6,
                    "gridRowEnd": 7
                }
            ],
            "gridColumns": "250px auto",
            "gridRows": "auto",
            "gap": 30,            
            carousel_nav_type: NAVIGATION_DESIGN_TYPE.LONG_ARROW,
            carousel_nav_position: NAVIGATION_POSITION_TYPE.MIDDLE_OUTER,
            carousel_nav: NAVIGATION_TYPE.SQUARE,
            carousel_nav_size: NAVIGATION_SIZE_TYPE.GIANT,
            "style": {
                "backgroundColor": "var(--force-plain-secondary-opacity-color)",
                "border": "1px solid var(--force-mini-contast-color)"
            },
            "card_fields": {
                "avatar": {
                    "margin": 2,
                    "hover_size": 8,
                    "icon": "https://i.pinimg.com/736x/01/29/85/012985ea99c16d87137ffcdbb92046b0.jpg",
                    "style": {
                        "height": "100%",
                        "width": "100%",                        
                        gridRowStart: 1,
                        gridRowEnd: 20,
                    }
                },
                "first_name": {
                    "style": {
                        "padding": 0,
                        "paddingTop": 12
                    }
                },
                "last_name": {
                    "style": {
                        "padding": 0,
                        "paddingBottom": 12,
                        "fontSize": 20,
                        "textTransform": "uppercase",
                        "fontFamily": "Open sans"
                    }
                },
                "description": {
                    "style": {
                        "padding": "0 12px 12px 12px",
                        "fontSize": ".9em",
                        "letterSpacing": 1
                    }
                },
                "divider": {},
                "links": {
                    "personalLinkType": "minimal",
                    "style": {
                        "padding": "12px 0"
                    }
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "1",
                            "title": "Известность"
                        },
                        {
                            "id": "2",
                            "title": "Порядочность"
                        },
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Чистоплотность"
                        },
                        {
                            "id": "5",
                            "title": "Грация"
                        }
                    ],
                    "min": 0,
                    "max": 12,
                    "weight": 2
                },
                "roles": {
                    "className": "my-4",
                    "style": {
                        "padding": "20px 0"
                    }
                },
                order: {
                    style: {
                        position: "absolute",
                        right: 3,
                        top: 3,
                        width: 33,
                        height: 33,
                        backgroundColor: "var(--force-plain-opacity-color)",
                        color: "var(--force-contast-color)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }
                }
            },
        },
        {
            "border_radius": 5,
            "gap": 10,
            carousel_nav_type: NAVIGATION_DESIGN_TYPE.LONG_ARROW,
            carousel_nav_position: NAVIGATION_POSITION_TYPE.MIDDLE_OUTER,
            carousel_nav: NAVIGATION_TYPE.ROUND,
            carousel_nav_size: NAVIGATION_SIZE_TYPE.LARGE,
            is_back_image: true,
            back_image: "https://i.pinimg.com/736x/bb/13/4e/bb134eedca61a2bca9113c3b5dfdbc49.jpg",
            card_fields: {
                avatar: {
                    style: {
                        gridRowStart: 1,
                        gridRowEnd: 20,
                    }
                },
                background: {
                    style : {
                        height: 330,
                    }
                },
                display_name: {
                    style: {
                        "padding": 10,
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px 0 10px",
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "fontWeight": "bold",
                    }
                },
                first_name: {
                    style: {
                        "padding": "10px 10px 0 10px",
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px 0 10px",
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "fontWeight": "bold",
                        height:"auto,"
                    }
                },
                last_name: {
                    style: {
                        "padding": "0 10px 10px 10px",
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px 0 10px",
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "fontWeight": "bold",
                        height: "auto",
                        width: "auto"

                    }
                },
                order: {
                    "significant_zero": true,
                    "card_fields_style": {
                        "position": "absolute",
                        "top": 10,
                        "right": 10
                    },
                    "style": {
                        "borderRadius": 2,
                        color: "var(--force-contast-color)",
                        "fontFamily": "Yanone Kaffeesatz, sans-serif",
                        "fontSize": 50,
                        "opacity": 0.75,
                        "width": 70,
                        "height": 70,
                        "border": "#00000050 solid 1px",
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "backgroundColor": "var(--force-plain-opacity-color)"
                    }
                },
                description: {
                    "style": {
                        "padding": "0 12px 12px 12px",
                        "fontSize": ".9em",
                        "letterSpacing": 1,
                        color: "var(--force-contast-color)",
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px"
                    }
                },
                divider: {},
                links: {
                    "personalLinkType": "small_minimal",
                    "card_fields_style": { 
                        position: "absolute",
                        top:0,
                        left:0
                    },
                    "style": {
                        //"padding": "12px 0",
                        //"backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": 10,
                        display: "block"
                    }
                },
                statistic_line: {
                    items: [
                        {
                            "id": "8-1",
                            "title": "Известность"
                        },
                        {
                            "id": "8-2",
                            "title": "Порядочность"
                        },
                        {
                            "id": "8-3",
                            "title": "Талант"
                        },
                        {
                            "id": "8-4",
                            "title": "Чистоплотность"
                        }
                    ],
                    min: 0,
                    max: 5,
                    style: {
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px"
                    }
                },
                roles: {
                    className: "my-1",
                    style: {
                        "padding": "5px 0",
                        "backgroundColor": "var(--force-plain-opacity-color)",
                        "margin": "0px 10px",
                        "width": "auto"
                    }
                },
                empty: {
                    style: {
                        width: "100%",
                        height: 10
                    }
                }
            },
        }
    ]
}
 